'use strict';

document.addEventListener('DOMContentLoaded', function () {
      const scrollOffset = 40;

      // クリックイベントを追加
      document.addEventListener('click', function (e) {
            const anchor = e.target.closest('a[href]');
            if (!anchor) return;

            // 新規タブ／修飾キー／ダウンロードなどは邪魔しない
            if (
                  anchor.target === '_blank' ||
                  anchor.hasAttribute('download') ||
                  e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ||
                  e.button !== 0
            ) return;

            const href = anchor.getAttribute('href');
            if (!href) return;

            // ハッシュリンク（同一ページ内アンカー）
            if (href.startsWith('#')) {
                  const hashName = parseHashName(href);
                  // 「#」のみの場合はページTOPへスムーススクロール
                  if (hashName === '#' || hashName === '') {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        e.preventDefault();
                        history.pushState(null, '', '#');
                        return;
                  }
                  const scrolled = scrollToAnchorSmoothly(hashName, scrollOffset);
                  if (scrolled) {
                        e.preventDefault();
                        history.pushState(null, '', href);
                  }
                  return;
            }

            // "/#xxx" や "/index.html#xxx" などを「TOPへのアンカー」として扱う
            // ※絶対URL/相対URLも考慮して URL() で正規化
            let url;
            try {
                  url = new URL(href, window.location.href);
            } catch {
                  return; // 解釈できないhrefは無視
            }

            const hasHash = !!url.hash && url.hash !== '#';
            if (!hasHash) return;

            const currentPath = getNormalizedPath(window.location.pathname);
            const linkPath = getNormalizedPath(url.pathname);

            // TOPページ向け（リンクが TOP を指している想定）
            // 例: 今が下層ページで、href="/#catA" → 遷移してからスクロール
            const linkIsTop = isTopPage(linkPath);

            // 同一ページ内のアンカー（パスが同じ）→ その場でスムーススクロール
            if (linkPath === currentPath) {
                  const hashName = parseHashName(url.hash);
                  const scrolled = scrollToAnchorSmoothly(hashName, scrollOffset);
                  if (scrolled) {
                        e.preventDefault();
                        history.pushState(null, '', url.hash);
                  }
                  return;
            }

            // TOPページへのアンカー（/#xxx）
            // (a) 今がTOPならその場でスクロール
            // (b) 下層ならTOPへ遷移（hash付き）して、到達後に自動でスクロールscrollToHashOnLoad()
            if (linkIsTop) {
                  if (isTopPage(currentPath)) {
                        const scrolled = scrollToAnchorSmoothly(url.hash, scrollOffset);
                        if (scrolled) {
                              e.preventDefault();
                              history.pushState(null, '', url.hash);
                        }
                  }
            }

      }, { passive: false });

      scrollToHashOnLoad(scrollOffset);
});

// ページ読み込み時にハッシュがあればスクロール
function scrollToHashOnLoad(scrollOffset) {
      // location.hash 例: #tab?data-tab=owner
      const hash = window.location.hash;
      if (!hash || hash === '#') return;

      const hashName = parseHashName(hash);

      window.scrollTo(0, 0);
      requestAnimationFrame(() => {
            setTimeout(() => {
                  scrollToAnchorSmoothly(hashName, scrollOffset);
            }, 500);
      });
}

// TOPページ判定（必要なら増やす）
function isTopPage(pathname) {
      return (
            pathname === '/' ||
            pathname === '/index.html' ||
            pathname === '/index.php'
      );
}

// "/index.html（php）" を "/" と同一扱いするための関数
function getNormalizedPath(pathname) {
      if (pathname.endsWith('/index.html') || pathname.endsWith('/index.php')) {
            return pathname.replace(/\/index\.(html|php)$/, '/') || '/';
      }
      return pathname || '/';
}

// スムーススクロールの関数
export function scrollToAnchorSmoothly(hash, scrollOffset) {
      if (!hash || hash === '#') return false;
      // IDを安全なCSSセレクタに変換（CSS.escape がないブラウザ保険）
      const safeId = (window.CSS && CSS.escape) ? CSS.escape(hash.slice(1)) : hash.slice(1).replace(/([ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~])/g, '\\$1');

      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;
      const target = document.getElementById(hash.slice(1)) || document.querySelector(`#${safeId}`);

      if (!target) return false;
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight - scrollOffset;
      window.scrollTo({
            top: position,
            behavior: 'smooth'
      });

      return true;
}

// ハッシュとクエリを分離し、ハッシュ名のみ返すユーティリティ関数
function parseHashName(hash) {
      if (hash && hash.includes('?')) {
            return hash.split('?')[0];
      }
      return hash;
}
